import { render, staticRenderFns } from "./ru.vue?vue&type=template&id=a3bd3d86&scoped=true&"
import script from "./ru.vue?vue&type=script&lang=js&"
export * from "./ru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bd3d86",
  null
  
)

export default component.exports